import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Factory, Flame, CheckCircle2, ShieldCheck, Users, Award, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Features = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-50 via-white to-orange-50 py-20 lg:py-32">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              Why Choose <span className="text-orange-600">Shriram Spectape</span>
            </h1>
            <p className="text-lg lg:text-xl text-gray-600 leading-relaxed mb-8">
              Industry-leading adhesive solutions backed by decades of expertise, innovation, and commitment to quality
            </p>
          </div>
        </div>
      </section>

      {/* Key Features Grid */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Card className="border-2 hover:border-orange-300 transition-all hover:shadow-xl">
              <CardHeader>
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <Factory className="h-8 w-8 text-orange-600" />
                </div>
                <CardTitle className="text-2xl">Contract Manufacturing</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  Customized adhesive tape solutions tailored to your specific industrial requirements with flexible production capabilities and scalable operations.
                </CardDescription>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-orange-300 transition-all hover:shadow-xl">
              <CardHeader>
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <Flame className="h-8 w-8 text-orange-600" />
                </div>
                <CardTitle className="text-2xl">High Temperature Resistance</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  Engineered to withstand extreme temperatures from -20°C to +260°C for demanding industrial applications across various sectors.
                </CardDescription>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-orange-300 transition-all hover:shadow-xl">
              <CardHeader>
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <ShieldCheck className="h-8 w-8 text-orange-600" />
                </div>
                <CardTitle className="text-2xl">Robust Quality Standards</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  Rigorous quality control and testing ensure consistent performance across all product lines and applications with certifications.
                </CardDescription>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-orange-300 transition-all hover:shadow-xl">
              <CardHeader>
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <CheckCircle2 className="h-8 w-8 text-orange-600" />
                </div>
                <CardTitle className="text-2xl">Wide Range of Applications</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  Comprehensive portfolio covering electrical insulation, sealing, mounting, packaging, and specialized industrial needs.
                </CardDescription>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-orange-300 transition-all hover:shadow-xl">
              <CardHeader>
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <Users className="h-8 w-8 text-orange-600" />
                </div>
                <CardTitle className="text-2xl">Expert Technical Support</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  Dedicated team providing guidance on tape selection, application methods, and custom solution development for your needs.
                </CardDescription>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-orange-300 transition-all hover:shadow-xl">
              <CardHeader>
                <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <Award className="h-8 w-8 text-orange-600" />
                </div>
                <CardTitle className="text-2xl">Certified & Compliant</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base">
                  Meeting international quality standards with materials tested for safety, durability, and environmental compliance.
                </CardDescription>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-600 to-orange-700 text-white">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-5xl font-bold mb-6">Ready to Experience Quality?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Discover how our specialty adhesive tapes can enhance your operations
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/products">
              <Button className="bg-white text-orange-600 hover:bg-gray-100 px-8 py-6 text-lg">
                View Products
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="border-white text-white hover:bg-white/10 px-8 py-6 text-lg">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Features;